export default {
      id: "icon--wear-heels-usage",
      viewBox: "0 0 31 30",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--wear-heels-usage",
      toString: function () {
        return this.url;
      }
    }